<h2 [innerHtml]="context.content | filterHTML"></h2>


// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/building-blocks/heading/heading.component.html